import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { permissionGuard } from 'app/core/guards/permission.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// export const appRoutes: Routes = [
//     {
//         path: '',
//         redirectTo: 'players',
//         pathMatch: 'full'
//     },
//     {
//         path: 'players',
//         component: PlayersList,
//         title: 'Players List - PadelHub'
//     },
//     {
//         path: '**',
//         redirectTo: 'players'
//     }
// ];

export const appRoutes: Route[] = [
    // Redirect empty path to '/home'
    { path: '', pathMatch: 'full', redirectTo: 'home' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'forgot-password',
                loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes'),
            },
            {
                path: 'reset-password',
                loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes'),
            },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            {
                path: 'onboarding/conectar',
                loadComponent: () => import('app/modules/onboarding/connect-provider.component').then(m => m.ConnectProviderComponent),
            },
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            // Home
            { path: 'home', loadChildren: () => import('app/modules/home/home.routes') },

            // Analysis Tools
            { path: 'league', loadChildren: () => import('app/modules/league/league.routes') },

            // Catalanas
            { path: 'catalanas', loadChildren: () => import('app/modules/catalanas/catalanas.routes') },

            // Stats
            { path: 'stats', loadChildren: () => import('app/modules/stats/stats.routes') },

            // Settings (captain + admin)
            {
                path: 'settings',
                loadChildren: () => import('app/modules/settings/settings.routes'),
            },

            // Test Tool
            { path: 'test', loadChildren: () => import('app/modules/test/test.routes') },
        ],
    },

    // Errors
    { path: 'error/401', pathMatch: 'full', loadChildren: () => import('app/pages/error/error-401/error-401.routes') },
    { path: 'error/403', pathMatch: 'full', loadChildren: () => import('app/pages/error/error-403/error-403.routes') },
    { path: 'error/404', pathMatch: 'full', loadChildren: () => import('app/pages/error/error-404/error-404.routes') },
    { path: 'error/500', pathMatch: 'full', loadChildren: () => import('app/pages/error/error-500/error-500.routes') },
    { path: '**', redirectTo: 'error/404' },
];
